import { useState } from "react";
import PAGES from "../utls/pages";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@material-ui/core";
import httpClient from "../services.httpClient";
import CreateUser from "../components/CreateUser";
import { useQuery } from "react-query";
import { Edit } from "@material-ui/icons";

function User({ page }) {
  const { data: users = [] } = useQuery({
    queryFn: async () => {
      const res = await httpClient.get("/users");
      return res.data.users;
    },
    queryKey: ["users"],
  });

  const { data: playlists = [] } = useQuery({
    queryFn: async () => {
      const res = await httpClient.get("/playlists");
      return res.data.playlists;
    },
    queryKey: ["playlists"],
  });

  const [isCreateUserOpen, setIsCreateUserOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  return (
    <div style={{ display: page === PAGES.users ? "block" : "none" }}>
      <CreateUser
        setIsOpen={setIsCreateUserOpen}
        open={isCreateUserOpen}
        playlists={playlists}
        currentUser={currentUser}
        setCurrentUser={setCurrentUser}
      />
      <Card>
        <CardContent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h2>User Information</h2>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setIsCreateUserOpen(true)}
            >
              Create User
            </Button>
          </div>

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Email</TableCell>
                  <TableCell>Password</TableCell>
                  <TableCell>Playlists</TableCell>
                  <TableCell>Admin</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users?.map((row) => (
                  <TableRow
                    key={row._id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.email}
                    </TableCell>
                    <TableCell>{row.password}</TableCell>
                    <TableCell>{row.spotifyIds?.length}</TableCell>
                    <TableCell>{row.isAdmin ? "Yes" : "No"}</TableCell>
                    {!row.isAdmin && (
                      <TableCell>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setCurrentUser(row);
                            setIsCreateUserOpen(true);
                          }}
                        >
                          <Edit />
                        </Button>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </div>
  );
}

export default User;
